import * as React from 'react';
import './Loader.scss';
import { SettingOutlined } from '@ant-design/icons/lib';

export const ChangeUserStatusLoader = () => (
    <div className="loader change-user-loader">
        <SettingOutlined spin />
    </div>
);
